var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 212,
    viewBox: "0 0 204 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.837 203.313C157.98 203.313 203.494 157.8 203.494 101.657C203.494 45.5132 157.98 0 101.837 0C45.6937 0 0.18042 45.5132 0.18042 101.657C0.18042 157.8 45.6937 203.313 101.837 203.313Z",
    fill: "url(#paint0_linear_27669_79342)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.436 114.229C191.232 109.328 176.645 106.982 167.536 110.399C158.987 113.608 160.361 119.973 151.589 122.602C137.433 126.844 127.625 112.139 106.561 112.838C87.8186 113.459 81.3235 125.573 67.1634 122.602C58.3323 120.75 56.6612 115.158 50.374 111.213C39.8421 104.602 19.6213 104.673 0.18042 108.454C1.95183 133.923 13.0779 156.812 30.1458 173.696C49.3453 177.251 70.2346 179.151 90.615 178.392C126.426 177.061 162.645 167.461 187.315 156.028C195.21 143.661 200.509 129.473 202.44 114.229H202.436Z",
    fill: "url(#paint1_linear_27669_79342)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5734 53.1986H11.3449C10.2794 53.1986 9.30489 52.7989 8.55066 52.1336C7.61924 51.3119 7.02783 50.0881 7.02783 48.7202C7.02783 47.484 7.5115 46.3644 8.29207 45.5551C9.07264 44.7458 10.1525 44.2444 11.3449 44.2444H29.5734C30.7658 44.2444 31.8457 44.7458 32.6262 45.5551C33.4068 46.3644 33.8905 47.484 33.8905 48.7202C33.8905 49.9565 33.4068 51.0761 32.6262 51.8854C31.8457 52.6947 30.7658 53.1961 29.5734 53.1961V53.1986Z",
    fill: "#D8E2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4058 52.6719C23.042 52.6719 25.9897 49.7241 25.9897 46.0879C25.9897 42.4517 23.042 39.5039 19.4058 39.5039C15.7695 39.5039 12.8218 42.4517 12.8218 46.0879C12.8218 49.7241 15.7695 52.6719 19.4058 52.6719Z",
    fill: "#D8E2F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.306 38.9772H161.215C159.51 38.9772 157.963 38.2685 156.846 37.1258C155.729 35.9831 155.036 34.4008 155.036 32.6566C155.036 31.4122 155.387 30.2503 155.994 29.2724C157.09 27.5061 159.018 26.3359 161.215 26.3359H187.306C189.012 26.3359 190.559 27.0446 191.676 28.1873C192.793 29.3301 193.486 30.9123 193.486 32.6566C193.486 34.2855 192.884 35.7688 191.896 36.8895C190.765 38.1723 189.127 38.9772 187.306 38.9772Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.206 30.1493C182.035 25.0457 178.569 20.2368 173.465 19.4084C168.362 18.58 163.553 22.0457 162.724 27.1493C161.896 32.2529 165.362 37.0617 170.465 37.8901C175.569 38.7186 180.378 35.2529 181.206 30.1493Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.391 75.3451C114.444 76.1073 114.051 76.8054 113.636 77.4041C110.876 81.3897 104.525 85.6094 100.308 82.8456C100.796 82.7572 102.057 82.7904 103.053 82.5783C105.418 82.079 106.99 79.556 108.284 77.287C109.076 75.8974 109.304 71.8964 110.827 71.3728C112.28 70.8735 114.285 73.8273 114.391 75.3451Z",
    fill: "#6D3944"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.026 77.4243C102.103 75.0824 103.199 73.5889 104.634 71.9165C106.069 70.2463 108.015 68.9936 110.095 69.0003C110.342 69.0003 110.598 69.0224 110.819 69.1461C111.073 69.2897 111.254 69.5504 111.426 69.8044C112.38 71.2029 114.222 73.0808 114.367 75.025C110.764 74.6428 106.97 75.9197 104.011 78.2108C101.803 79.923 100.467 83.0822 100.233 83.0778C98.0139 83.0248 100.52 78.5267 101.026 77.4265V77.4243Z",
    fill: "#FFAA9D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0966 78.2502C85.1562 79.0102 85.6508 79.6377 86.1499 80.1613C89.4687 83.6519 96.3692 86.7979 100.125 83.3846C99.6306 83.3758 98.3874 83.6122 97.3739 83.5636C94.9626 83.4509 93.0349 81.2129 91.4185 79.1826C90.4271 77.9365 89.61 74.0217 88.0268 73.7499C86.5164 73.4915 84.9751 76.7347 85.0966 78.2502Z",
    fill: "#6D3944"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6101 78.1466C97.1991 76.0058 95.8941 74.7068 94.2269 73.2884C92.5598 71.87 90.4532 70.9444 88.3996 71.289C88.1545 71.3288 87.9072 71.3906 87.7062 71.5519C87.4766 71.7331 87.3353 72.0225 87.2028 72.3008C86.4675 73.8363 84.9284 75.9881 85.0741 77.9323C88.5762 76.9735 92.5156 77.6208 95.7792 79.4081C98.2148 80.7425 100.006 83.6499 100.235 83.6057C102.419 83.1948 99.277 79.1562 98.6123 78.1488L98.6101 78.1466Z",
    fill: "#FFAA9D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M124.562 119.288L82.2646 122.725L79.4448 85.0062L121.742 81.5686L124.562 119.288Z",
    fill: "url(#paint2_linear_27669_79342)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.346 90.7347L77.266 94.6407L76.5549 85.1165L124.633 81.2104L125.346 90.7347Z",
    fill: "#467DFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9604 94.3848L122.454 91.0952L122.707 94.4909L81.9604 94.3848Z",
    fill: "black"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.667 120.823L100.431 121.247L97.5761 83.0556C97.5474 82.669 97.8102 82.331 98.1635 82.3023L102.12 81.9819C102.474 81.9532 102.783 82.2448 102.812 82.6315L105.667 120.823Z",
    fill: "#FFAA9D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27669_79342)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.155 157.46L191.277 187.831C195.243 191.967 194.114 199.23 188.8 203.716C183.565 208.131 176.372 208.091 172.915 203.616L146.8 169.808",
    fill: "#5792FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M162.155 157.46L191.277 187.831C195.243 191.967 194.114 199.23 188.8 203.716C183.565 208.131 176.372 208.091 172.915 203.616L146.8 169.808",
    fill: "url(#paint3_linear_27669_79342)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.82 169.809L128.098 145.572L140.726 135.112L162.155 157.461",
    fill: "#12131F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.429 80.7348C159.648 44.2501 122.354 21.662 85.1401 30.2737C47.9162 38.8753 24.8685 75.4299 33.65 111.905C42.4315 148.379 79.7253 170.977 116.949 162.366C154.173 153.754 177.221 117.209 168.439 80.7348H168.429ZM112.973 145.872C85.0502 152.325 57.0773 135.382 50.4837 108.018C43.8901 80.6548 61.1833 53.2314 89.1062 46.7777C117.029 40.3239 145.002 57.2675 151.596 84.631C158.189 111.994 140.896 139.418 112.973 145.872Z",
    fill: "url(#paint4_linear_27669_79342)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.045 147.231C129.73 147.231 152.984 124.437 152.984 96.3201C152.984 68.2029 129.73 45.4094 101.045 45.4094C72.3592 45.4094 49.105 68.2029 49.105 96.3201C49.105 124.437 72.3592 147.231 101.045 147.231Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M133.186 52.919L108.709 44.9264L43.6035 125.208L63.2705 140.813L133.186 52.919Z",
    fill: "url(#paint5_linear_27669_79342)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M149.17 70.9017L143.176 59.9124L70.9537 151.313L79.9693 158.467L149.17 70.9017Z",
    fill: "url(#paint6_linear_27669_79342)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.9 83.2823C150.956 54.4303 121.455 36.5576 92.0134 43.371C75.3895 47.2173 62.3522 58.1067 55.3889 72.0432C62.2023 59.7451 74.1208 50.2344 89.1062 46.7677C117.029 40.314 145.002 57.2576 151.596 84.621C158.189 111.985 140.896 139.408 112.973 145.862C96.8787 149.578 80.7843 145.522 68.756 136.181C81.5935 147.061 99.3963 151.956 117.179 147.85C146.621 141.036 164.853 112.134 157.9 83.2823Z",
    fill: "#12131F",
    fillOpacity: 0.77
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27669_79342",
    x: 29.6768,
    y: 28.4426,
    width: 166.079,
    height: 182.771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.10687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05344
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27669_79342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27669_79342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27669_79342",
    x1: 101.837,
    y1: 183.113,
    x2: 101.837,
    y2: -20.1969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27669_79342",
    x1: 101.307,
    y1: 174.964,
    x2: 101.307,
    y2: 116.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EBF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27669_79342",
    x1: 102,
    y1: 99.3644,
    x2: 102,
    y2: 130.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3162DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#173DB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27669_79342",
    x1: 151.476,
    y1: 161.886,
    x2: 191.217,
    y2: 205.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27669_79342",
    x1: 126.692,
    y1: 22.948,
    x2: 75.7411,
    y2: 164.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27669_79342",
    x1: 111.105,
    y1: 57.8563,
    x2: 66.6964,
    y2: 114.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27669_79342",
    x1: 134.786,
    y1: 78.9878,
    x2: 89.9623,
    y2: 136.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/emptyIcon.679f63e50f1a3bdb7ecd31785bef65ed.svg";
export { ForwardRef as ReactComponent };